import React from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonShowHide.module.scss';

type ButtonShowHideProps = {
  onClick: () => void
  currentState: boolean
}

const ButtonShowHide = ({onClick, currentState}: ButtonShowHideProps) => {
  const intl = useIntl();
  const labelText = currentState
    ? intl.formatMessage({id: 'invoices-form-showLess', defaultMessage: 'Hide'})
    : intl.formatMessage({id: 'invoices-form-showMore', defaultMessage: 'Advanced'});

  return (
    <ButtonAction
      variant={'link'}
      label={labelText}
      onClick={onClick}
      customClassnames={{
        container: styles.buttonContainer
      }}
    />
  );
};

export default ButtonShowHide;
